var _path, _g, _path2, _path3, _path4, _g2, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPewFeedIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 80,
    viewBox: "0 0 110 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M40.5 80C62.5914 80 80.5 62.0914 80.5 40C80.5 17.9086 62.5914 0 40.5 0C18.4086 0 0.5 17.9086 0.5 40C0.5 62.0914 18.4086 80 40.5 80Z",
    fill: "#EAECF0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2407_17745)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.0517 17H94.9483C95.625 17 96.2741 17.3161 96.7526 17.8787C97.2312 18.4413 97.5 19.2044 97.5 20L97.5 35C97.5 35.7957 97.2312 36.5587 96.7526 37.1213C96.2741 37.6839 95.625 38 94.9483 38H26.0517C25.375 38 24.7259 37.6839 24.2474 37.1213C23.7688 36.5587 23.5 35.7957 23.5 35L23.5 20C23.5 19.2044 23.7688 18.4413 24.2474 17.8787C24.7259 17.3161 25.375 17 26.0517 17V17Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M64.9 21.8003H49.3C48.3059 21.8003 47.5 22.6062 47.5 23.6003C47.5 24.5944 48.3059 25.4003 49.3 25.4003H64.9C65.8941 25.4003 66.7 24.5944 66.7 23.6003C66.7 22.6062 65.8941 21.8003 64.9 21.8003Z",
    fill: "#47AD1D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7 29.6001H49.3C48.3059 29.6001 47.5 30.406 47.5 31.4001C47.5 32.3942 48.3059 33.2001 49.3 33.2001H75.7C76.6941 33.2001 77.5 32.3942 77.5 31.4001C77.5 30.406 76.6941 29.6001 75.7 29.6001Z",
    fill: "#EAECF0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M40.5 27.5C40.5 23.9101 37.5899 21 34 21C30.4101 21 27.5 23.9101 27.5 27.5C27.5 31.0899 30.4101 34 34 34C37.5899 34 40.5 31.0899 40.5 27.5Z",
    fill: "#47AD1D"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2407_17745)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0517 42H83.9483C84.625 42 85.2741 42.3161 85.7526 42.8787C86.2312 43.4413 86.5 44.2044 86.5 45L86.5 60C86.5 60.7957 86.2312 61.5587 85.7526 62.1213C85.2741 62.6839 84.625 63 83.9483 63H15.0517C14.375 63 13.7259 62.6839 13.2474 62.1213C12.7688 61.5587 12.5 60.7957 12.5 60L12.5 45C12.5 44.2044 12.7688 43.4413 13.2474 42.8787C13.7259 42.3161 14.375 42 15.0517 42V42Z",
    fill: "white"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M53.9 46.8003H38.3C37.3059 46.8003 36.5 47.6062 36.5 48.6003C36.5 49.5944 37.3059 50.4003 38.3 50.4003H53.9C54.8941 50.4003 55.7 49.5944 55.7 48.6003C55.7 47.6062 54.8941 46.8003 53.9 46.8003Z",
    fill: "#47AD1D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7 54.6001H38.3C37.3059 54.6001 36.5 55.406 36.5 56.4001C36.5 57.3942 37.3059 58.2001 38.3 58.2001H64.7C65.6941 58.2001 66.5 57.3942 66.5 56.4001C66.5 55.406 65.6941 54.6001 64.7 54.6001Z",
    fill: "#EAECF0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M29.5 52.5C29.5 48.9101 26.5899 46 23 46C19.4101 46 16.5 48.9101 16.5 52.5C16.5 56.0899 19.4101 59 23 59C26.5899 59 29.5 56.0899 29.5 52.5Z",
    fill: "#47AD1D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2407_17745",
    x: 15.3254,
    y: 8.82545,
    width: 94,
    height: 41,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.82545,
    dy: 1.82545
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.230539 0 0 0 0 0.370572 0 0 0 0 0.482993 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2407_17745"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2407_17745",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2407_17745",
    x: 4.32545,
    y: 33.8254,
    width: 94,
    height: 41,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.82545,
    dy: 1.82545
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.230539 0 0 0 0 0.370572 0 0 0 0 0.482993 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2407_17745"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2407_17745",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPewFeedIcon);
export default __webpack_public_path__ + "static/media/pew-feed-icon.47d0492a1f711c9cce4d1a92ea538d84.svg";
export { ForwardRef as ReactComponent };